import type {LocalizationContextType} from 'localization/context/types';
import type {Part} from 'schemaDefinition/types';
import type {SchemaName} from 'schemas/types';
import {getFieldRootKeys, getLabel} from 'schema/form/functions';

export const getSchemaPartLabel = (
  schemaKey: SchemaName,
  part: Pick<Part, 'name' | 'key'>,
  localization: LocalizationContextType,
): string => {
  const rootKeys = getFieldRootKeys(schemaKey, false, part.key, part.name);
  return (
    getLabel(rootKeys, !!part.key, localization) ??
    `Missing label for ${part.name}`
  );
};
